import { Box } from '@mui/material';
import { FormTitleBox, LoadingSkeleton, ConfirmationDialog } from '../../common/components';
import UsersDataTable from './components/UsersDataTable';
import UsersPagination from './components/UsersPagination';
import UserDialog from './components/UserDialog';
import { useUsersTable } from './hooks/useUsersTable';
import PersonAddIcon from '@mui/icons-material/PersonAdd';

const UsersTable = () => {
  const {
    data,
    isLoading,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    searchTerm,
    dialogOpen,
    editMode,
    selectedUser,
    roles,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
    handleOpenDialog,
    handleCloseDialog,
    handleInputChange,
    handleSelectChange,
    handleSave,
    handleEdit,
    handleDelete,
    deleteConfirmOpen,
    userToDelete,
    handleConfirmDelete,
    handleCancelDelete,
  } = useUsersTable();

  return (
    <Box>
      <FormTitleBox
        title="Administración | Usuarios"
        showButton={true}
        buttonText="Agregar Usuario"
        buttonIcon={PersonAddIcon}
        onButtonClick={handleOpenDialog}
        showSearch={true}
        searchLabel="Buscar usuario"
        searchValue={searchTerm}
        onSearchChange={handleSearch}
        searchSize="medium"
      />

      <UsersDataTable
        data={data}
        isLoading={isLoading}
        onEdit={handleEdit}
        onDelete={handleDelete}
        roles={roles}
        LoadingComponent={LoadingSkeleton}
      />

      <UsersPagination
        totalPages={totalPages}
        totalCount={totalCount}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <UserDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        editMode={editMode}
        selectedUser={selectedUser}
        onInputChange={handleInputChange}
        onSelectChange={handleSelectChange}
        onSave={handleSave}
        roles={roles}
      />

      <ConfirmationDialog
        open={deleteConfirmOpen}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
        entityName="usuario"
        message={`¿Está seguro que quiere eliminar al usuario "${userToDelete?.names}" de forma permanente?`}
      />
    </Box>
  );
};

export default UsersTable;
